
import VueLazyload from 'vue-lazyload'

export default defineNuxtPlugin((app) => {
  app.vueApp.use(VueLazyload)
})